import { render } from "./ChartCompany.vue?vue&type=template&id=4540e3a2"
import script from "./ChartCompany.vue?vue&type=script&lang=js"
export * from "./ChartCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__